var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00ACC1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    stroke: "#00ACC1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.394,3.081l-7-3c-0.308-0.132-0.663-0.102-0.944,0.084C55.169,0.35,55,0.664,55,1v6v23H37v-7c0-2.757-2.321-5-5.078-5 H26v-3h4.922C33.679,15,36,12.757,36,10V1c0-0.552-0.525-1-1.078-1h-4C30.369,0,30,0.448,30,1v8h-4.89 c0.513-1,0.812-1.907,0.812-3c0-3.309-2.691-6-6-6s-6,2.691-6,6c0,1.294,0.416,2.49,1.115,3.471l-5.572,5.572 C8.521,15.988,8,17.243,8,18.579c0,1.335,0.521,2.591,1.465,3.535l3.671,3.672c0.188,0.188,0.441,0.293,0.707,0.293 s0.559-0.106,0.746-0.293L16,24.414V39c0,0.552,0.369,1,0.922,1h0.104C16.391,41,16,41.87,16,43s0.391,2,1.026,3H13 c-2.757,0-5,2.243-5,5c0,1.13,0.391,2,1.026,3H5c-2.757,0-5,2.243-5,5s2.243,5,5,5h28c0.379,0,0.725-0.214,0.894-0.553 c0.169-0.339,0.133-0.744-0.095-1.047c-1.405-1.874-1.477-4.4-0.251-6.4H41c0.379,0,0.725-0.214,0.894-0.553 c0.169-0.339,0.133-0.744-0.095-1.047c-1.405-1.875-1.477-4.4-0.251-6.4H49c0.379,0,0.725-0.214,0.894-0.553 c0.169-0.339,0.133-0.744-0.095-1.047c-1.405-1.874-1.477-4.4-0.251-6.4H57c0.379,0,0.725-0.214,0.894-0.553 c0.169-0.339,0.133-0.744-0.095-1.047c-1.501-2.002-1.501-4.798,0-6.8c0.227-0.303,0.264-0.709,0.095-1.047 C57.725,30.214,57.379,30,57,30V7.659l6.394-2.74C63.762,4.762,64,4.4,64,4S63.762,3.238,63.394,3.081z M19.922,2 c2.206,0,4,1.794,4,4s-1.794,4-4,4s-4-1.794-4-4C15.922,3.795,17.716,2,19.922,2z M16,19.744l-1.165-1.165L16,17.414V19.744z M16.215,14.293l-3.579,3.579c-0.188,0.188-0.293,0.442-0.293,0.707c0,0.265,0.105,0.519,0.293,0.707l2.793,2.793l-1.586,1.585 L10.879,20.7C10.312,20.133,10,19.38,10,18.579c0-0.801,0.312-1.555,0.879-2.122l5.572-5.572C17.432,11.584,18.628,12,19.922,12 c1.223,0,2.36,0,3.31-1h7.69C31.475,11,32,10.552,32,10V2h2v8c0,1.654-1.424,3-3.078,3h-6C24.369,13,24,13.448,24,14v5 c0,0.552,0.369,1,0.922,1h7C33.576,20,35,21.346,35,23v7h-3v-6c0-0.552-0.525-1-1.078-1h-9C21.369,23,21,23.448,21,24v14h-3V15 c0-0.404-0.282-0.769-0.656-0.924C16.97,13.921,16.501,14.007,16.215,14.293z M25.026,38H23V25h7v5h-1c-2.757,0-5,2.243-5,5 C24,36.13,24.391,37,25.026,38z M5,62c-1.654,0-3-1.346-3-3s1.346-3,3-3h8h18.281c-0.271,1-0.443,1-0.532,2H7v2h23.75 c0.089,1,0.26,1,0.532,2H5z M33,54H13c-1.654,0-3-1.346-3-3s1.346-3,3-3h8h18.281c-0.271,1-0.443,1-0.532,2H23v2h15.75 c0.089,1,0.26,1,0.532,2H33z M46.75,44c0.089,1,0.26,1,0.531,2H41H21c-1.654,0-3-1.346-3-3s1.346-3,3-3h0.922H29h18.281 c-0.271,1-0.443,1-0.531,2H38v2H46.75z M54.75,36c0.089,1,0.26,1,0.531,2H49H29c-1.654,0-3-1.346-3-3s1.346-3,3-3h1.922h5h19.359 c-0.271,1-0.443,1-0.531,2H39v2H54.75z M57,5.484V2.517L60.461,4L57,5.484z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7,
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.242,6.03c-2.108-0.527-3.745-2.165-4.273-4.273C46.859,1.313,46.459,1,46,1s-0.859,0.312-0.97,0.757 c-0.527,2.108-2.164,3.745-4.272,4.273C40.312,6.141,40,6.541,40,7s0.312,0.859,0.758,0.97c2.108,0.527,3.745,2.165,4.272,4.272 C45.141,12.688,45.541,13,46,13s0.859-0.312,0.97-0.757c0.527-2.108,2.164-3.745,4.273-4.272C51.688,7.859,52,7.459,52,7 S51.688,6.141,51.242,6.03z M46,9.478C45.371,8.476,44.524,7.629,43.522,7C44.524,6.371,45.371,5.525,46,4.523 C46.629,5.525,47.476,6.371,48.477,7C47.476,7.629,46.629,8.476,46,9.478z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 12,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 50,
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 50,
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 34,
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 34,
    width: 2,
    height: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.c546d2ddee5b6d278be806d4c1ca3b87.svg";
export { ForwardRef as ReactComponent };